<template>
  <base-card :loading="loading" class="rounded-lg">
    <v-tabs v-model="tab" show-arrows class="rounded-t-lg" height="36px">
      <v-tab
        v-for="tab in tabsFiltered"
        class="rounded-t-lg"
        :key="tab.component"
      >
        <v-icon left small>{{ tab.icon }}</v-icon>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" :touchless="tabsFiltered[tab]?.touchless">
      <v-tab-item v-for="item in tabsFiltered" :key="item.name" class="pt-2">
        <component :is="item.component" class="px-4 pb-4" />
      </v-tab-item>
    </v-tabs-items>
  </base-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Artist from "@/components/admin/registrations/Artist.vue";
import Banks from "@/components/admin/registrations/Banks.vue";
import MerchProducts from "@/components/admin/registrations/MerchProducts.vue";
export default {
  metaInfo() {
    return { title: `Cadastros` };
  },
  data: () => ({
    loading: false,
    tab: null,
    tabs: [
      {
        id: "artists",
        name: "Artistas",
        component: "Artist",
        icon: "mdi-account-multiple",
        permission: 1048576,
      },
      {
        id: "banks",
        name: "Bancos",
        component: "Banks",
        icon: "mdi-bank",
        permission: 1048576,
      },
      {
        id: "merchProducts",
        name: "Produtos",
        component: "MerchProducts",
        icon: "mdi-food-fork-drink",
        permission: 1048576,
      },
    ],
  }),
  methods: {},
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    tabsFiltered() {
      return this.tabs.filter(
        (tab) => !tab.permission || this.hasPermission(tab.permission)
      );
    },
  },
  watch: {},
  components: {
    Artist,
    Banks,
    MerchProducts,
  },
  mounted() {},
};
</script>

<style></style>
